import { index, Options } from 'shared/assets/styles';
import { BlurHashImage } from 'shared/components/connected/blur-hash-image';
import { typographyToCss } from 'shared/lib/mui';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  position: sticky;
  top: 0;
  z-index: ${index(Options.TOPBAR)};

  width: 100%;
  min-width: 0;

  border: ${({ theme }) => `1px solid ${theme.palette.divider}`};
  background: ${({ theme }) => theme.palette.background.default};
  border-radius: ${({ theme }) => theme.spacing(3)};
  box-shadow: ${({ theme }) => theme.shadowBox.contentBlock};
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
`;

export const TitleContainer = styled.div`
  flex: 1;
  display: flex;
  gap: ${({ theme }) => theme.spacing(1.5)};
  align-items: center;

  min-width: 0;
  overflow: hidden;

  color: ${({ theme }) => theme.palette.text.primary};
`;

export const IllustrationContainer = styled.span<{
  $color: string | null | undefined;
}>`
  position: relative;
  width: 2rem;
  min-width: 2rem;
  height: 2rem;
  min-height: 2rem;

  border-radius: ${({ theme }) => theme.spacing(1.5)};

  color: ${({ theme }) => theme.palette.grey[600]};
  font-size: 1.2rem;
  line-height: 62.5%;

  ${({ $color }) =>
    $color &&
    css`
      &::before {
        content: '';
        position: absolute;
        top: 0;
        right: 0;

        width: 0.6rem;
        height: 0.6rem;

        background: ${$color};
        border-radius: 50%;
        border: 1px solid ${({ theme }) => theme.palette.common.white};
        transform: translate(33%, -33%);
      }
    `}
`;

export const ImageContainer = styled.span`
  display: block;
  width: 100%;
  height: 100%;

  border-radius: ${({ theme }) => theme.spacing(1.5)};
  overflow: hidden;
`;

export const Image = styled(BlurHashImage)`
  display: block;
  width: 100%;
  height: 100%;

  object-fit: cover;
`;

export const IconContainer = styled.span`
  display: block;
  padding: ${({ theme }) => theme.spacing(1)};

  border-radius: ${({ theme }) => theme.spacing(1.5)};
  background: ${({ theme }) => theme.palette.grey[100]};
  overflow: hidden;

  line-height: 62.5%;
`;

export const Title = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.h6)};
  flex: 1;
  overflow: hidden;

  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const NavigationContainer = styled.div`
  padding: ${({ theme }) => `0 ${theme.spacing(6)}`};

  ${({ theme }) =>
    theme.isMobile &&
    css`
      display: none;
    `};
`;

export const InteractionsContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;

  ${({ theme }) =>
    theme.isMobile &&
    css`
      flex: initial;
    `};
`;

export const Interactions = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1.5)};

  position: relative;

  color: ${({ theme }) => theme.palette.grey[600]};
`;

export const FavoriteButtonContainer = styled.div<{ $isFavorite: boolean }>`
  ${({ theme, $isFavorite }) =>
    $isFavorite &&
    css`
      color: ${theme.palette.warning.main};
      fill: ${theme.palette.warning.main};
    `};
`;
